import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Request from '../../../../services/request';
import Notification from '../../../../services/notifications';
import translate from '../../../../commonComponents/translate';
import Form from '../../../../commonComponents/forms/Form';
import FormInput from '../../../../commonComponents/forms/FormInput';
import withCSRF from '../../../../commonComponents/withCSRF';
import { compose } from '../../../../services/utilityFunctions';

function ForgotForm({ t, _csrf, displayLoginForm }) {
  const [email, setEmail] = useState('');

  const resetForm = () => {
    setEmail('');
    $('#forgotPasswordForm').validate().resetForm();
  };

  const submitForm = () => {
    new Request(_csrf)
      .post('/signin/forgotPassword', { email_recover: email })
      .done(() => {
        resetForm();
        Notification.showNotificationSuccess(
          t('success'),
          t('forgetPasswordSuccess'),
        );
      })
      .fail(err => {
        const { error } = err?.responseJSON;
        resetForm();
        Notification.showNotificationError(
          t('error'),
          t(error) || t('forgetPasswordError'),
        );
      });
  };

  return (
    <div className="m-login__forget-password">
      <div className="m-login__head">
        <h3 className="m-login__title">{t('login_forgotPassword')}</h3>
      </div>
      <Form
        submitMethod={submitForm}
        validationRules={{
          email_recover: {
            required: true,
            email: true,
          },
        }}
        id="forgotPasswordForm"
        className="m-login__form m-form"
      >
        {submitHandler => (
          <>
            <FormInput
              type="email"
              placeholder="Email"
              name="email_recover"
              id="m_email"
              value={email}
              onChange={setEmail}
              inputProps={{ autoComplete: 'off' }}
              inputClassName="login-input"
            />
            <div className="m-login__form-action">
              <button
                type="button"
                className="btn login-button m-btn m-btn--pill m-btn--custom m-btn--air"
                onClick={submitHandler}
              >
                {t('login_request')}
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-secondary m-btn m-btn--pill m-btn--custom"
                onClick={displayLoginForm}
              >
                {t('cancel')}
              </button>
            </div>
          </>
        )}
      </Form>
    </div>
  );
}

ForgotForm.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  displayLoginForm: PropTypes.func.isRequired,
};

export default compose(translate, withCSRF)(ForgotForm);
